import { ContentSkeleton } from 'embroil/components/loading';

<template>
  <div class="index-loading">
    <div class="index-loading__header">
      <div class="index-loading__title"></div>
      <div class="index-loading__subtitle"></div>
    </div>
    
    <div class="index-loading__content">
      <ContentSkeleton 
        @itemCount={{4}}
        @showImages={{true}}
        class="index-loading__articles"
      />
      
      <div class="index-loading__sidebar">
        <ContentSkeleton 
          @itemCount={{3}}
          @showImages={{false}}
          @compact={{true}}
          class="index-loading__popular"
        />
      </div>
    </div>
  </div>

  <style>
    .index-loading {
      padding: 2rem;
      max-width: 1200px;
      margin: 0 auto;
    }

    .index-loading__header {
      margin-bottom: 2rem;
    }

    .index-loading__title {
      height: 32px;
      background: #f3f4f6;
      border-radius: 8px;
      width: 300px;
      animation: skeleton-pulse 1.5s ease-in-out infinite alternate;
      margin-bottom: 1rem;
    }

    .index-loading__subtitle {
      height: 20px;
      background: #f3f4f6;
      border-radius: 6px;
      width: 200px;
      animation: skeleton-pulse 1.5s ease-in-out infinite alternate;
      animation-delay: 0.1s;
    }

    .index-loading__content {
      display: grid;
      grid-template-columns: 1fr 300px;
      gap: 2rem;
    }

    @media (max-width: 768px) {
      .index-loading__content {
        grid-template-columns: 1fr;
        gap: 1.5rem;
      }
      
      .index-loading {
        padding: 1rem;
      }
    }

    @keyframes skeleton-pulse {
      0% {
        background: #f3f4f6;
      }
      100% {
        background: #e5e7eb;
      }
    }
  </style>
</template>